import React, { Component } from 'react';
import { renderToStaticMarkup } from 'react-dom/server'
import PropTypes from 'prop-types';
import { Form } from 'react-form';

import CheckboxInput from 'forms/CheckboxInput';

import paymentValidator from 'validators/paymentValidator';

// le paiement se fait sur la page Stripe Checkout, voir Cart#createOrder
class Payment extends Component {

  render() {
    const formOptions = {
      onSubmit: values => {
        this.props.createOrder(values)
      },
      validate: paymentValidator
    };

    return (
      <Form {...formOptions}>
        {formApi => {
          const inputOptions = {
            formApi,
          };

          return (
            <form className="cart-form" onSubmit={formApi.submitForm} noValidate>
              <h1 className="cart-formTitle">{App.t('cart.payment')}</h1>
              <div className="cart-paymentMessage">
                <p dangerouslySetInnerHTML={{ __html: App.t('cart.payment_text', { link: renderToStaticMarkup(<a href="https://stripe.com" target="_blank">Stripe.com</a>) }) }} />
              </div>

              <CheckboxInput name="termsAccepted" label={App.t('cart.accept_terms')} className="cart-termsInput" {...inputOptions} />
              <p className="cart-terms"><a href={_routes.termsPage} target="_blank">{App.t('cart.read_terms')}</a></p>

              {this.props.error && <p className="input-error">{this.props.error}</p>}

              <div className="input-buttons">
                <button className="btn -green">{App.t('cart.complete_order')}</button>
              </div>
            </form>
          )
        }}
      </Form>
    );
  }

}

Payment.propTypes = {
  createOrder: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default Payment;
